import { jsx as w } from "react/jsx-runtime";
import y from "clsx";
import '../../_assets/Typography.pdruYWD3.css';const p = "_headline_11e91_86", h = "_headline_1_11e91_92", S = "_headline_2_11e91_98", m = "_headlineSans_11e91_133", f = "_headlineSans_1_11e91_138", M = "_headlineSans_2_11e91_144", P = "_headlineSans_3_11e91_151", k = "_subtitle_11e91_203", x = "_subtitle_1_11e91_209", U = "_subtitle_2_11e91_215", T = "_subtitleMono_11e91_250", C = "_subtitleMono_1_11e91_256", B = "_subtitleMono_2_11e91_262", $ = "_body_11e91_300", v = "_body_1_11e91_306", N = "_body_2_11e91_312", j = "_body_3_11e91_318", z = "_bodyMono_11e91_325", I = "_bodyMono_1_11e91_331", R = "_bodyMono_2_11e91_337", q = "_bodyMono_3_11e91_343", A = "_caption_11e91_350", D = "_caption_1_11e91_356", E = "_captionMono_11e91_363", F = "_captionMono_1_11e91_369", G = "_captionMono_2_11e91_375", H = "_portalSubtitle_11e91_382", J = "_portalSubtitle_1_11e91_388", K = "_portalSubtitle_2_11e91_394", L = "_portalSubtitle_3_11e91_400", O = "_portalSubtitleBold_11e91_427", Q = "_portalSubtitleBold_1_11e91_433", V = "_portalSubtitleBold_2_11e91_439", W = "_portalText_11e91_460", X = "_portalText_1_11e91_466", Y = "_portalText_2_11e91_472", Z = "_portalCaption_11e91_493", __ = "_portalCaption_1_11e91_499", o_ = "_portalCaption_2_11e91_505", e_ = "_button_11e91_512", t_ = "_button_large_11e91_517", n_ = "_button_medium_11e91_523", r_ = "_button_small_11e91_529", l_ = "_buttonUnderline_11e91_536", c_ = "_buttonUnderline_large_11e91_541", s_ = "_buttonUnderline_medium_11e91_547", a_ = "_buttonUnderline_small_11e91_553", i_ = "_weight_400_11e91_568", d_ = "_weight_500_11e91_571", b_ = "_weight_700_11e91_574", u_ = "_fontStyle_normal_11e91_578", g_ = "_fontStyle_italic_11e91_581", w_ = "_noPadding_11e91_766", y_ = "_noPadding_top_11e91_770", p_ = "_noPadding_bottom_11e91_773", h_ = "_btn_11e91_777", S_ = "_disabled_11e91_785", _ = {
  headline: p,
  headline_1: h,
  headline_2: S,
  headlineSans: m,
  headlineSans_1: f,
  headlineSans_2: M,
  headlineSans_3: P,
  subtitle: k,
  subtitle_1: x,
  subtitle_2: U,
  subtitleMono: T,
  subtitleMono_1: C,
  subtitleMono_2: B,
  body: $,
  body_1: v,
  body_2: N,
  body_3: j,
  bodyMono: z,
  bodyMono_1: I,
  bodyMono_2: R,
  bodyMono_3: q,
  caption: A,
  caption_1: D,
  captionMono: E,
  captionMono_1: F,
  captionMono_2: G,
  portalSubtitle: H,
  portalSubtitle_1: J,
  portalSubtitle_2: K,
  portalSubtitle_3: L,
  portalSubtitleBold: O,
  portalSubtitleBold_1: Q,
  portalSubtitleBold_2: V,
  portalText: W,
  portalText_1: X,
  portalText_2: Y,
  portalCaption: Z,
  portalCaption_1: __,
  portalCaption_2: o_,
  button: e_,
  button_large: t_,
  button_medium: n_,
  button_small: r_,
  buttonUnderline: l_,
  buttonUnderline_large: c_,
  buttonUnderline_medium: s_,
  buttonUnderline_small: a_,
  weight_400: i_,
  weight_500: d_,
  weight_700: b_,
  fontStyle_normal: u_,
  fontStyle_italic: g_,
  "color_brand-green": "_color_brand-green_11e91_585",
  "color_brand-dark": "_color_brand-dark_11e91_588",
  "color_brand-white": "_color_brand-white_11e91_591",
  "color_orange-1": "_color_orange-1_11e91_594",
  "color_stone-1": "_color_stone-1_11e91_597",
  "color_green-1": "_color_green-1_11e91_600",
  "color_green-2": "_color_green-2_11e91_603",
  "color_green-3": "_color_green-3_11e91_606",
  "color_black-1": "_color_black-1_11e91_609",
  "color_black-2": "_color_black-2_11e91_612",
  "color_dark-2": "_color_dark-2_11e91_615",
  "color_grey-1": "_color_grey-1_11e91_618",
  "color_grey-2": "_color_grey-2_11e91_621",
  "color_grey-3": "_color_grey-3_11e91_624",
  "color_grey-4": "_color_grey-4_11e91_627",
  "color_grey-5": "_color_grey-5_11e91_630",
  "color_grey-6": "_color_grey-6_11e91_633",
  "color_grey-7": "_color_grey-7_11e91_636",
  "color_mint-1": "_color_mint-1_11e91_639",
  "color_mint-2": "_color_mint-2_11e91_642",
  "color_mint-3": "_color_mint-3_11e91_645",
  "color_secondary-grey-1": "_color_secondary-grey-1_11e91_648",
  "color_secondary-grey-4": "_color_secondary-grey-4_11e91_651",
  "color_secondary-grey-3": "_color_secondary-grey-3_11e91_654",
  "color_status-error": "_color_status-error_11e91_657",
  "color_status-error-bg": "_color_status-error-bg_11e91_660",
  "color_status-warning": "_color_status-warning_11e91_663",
  "color_status-warning-bg": "_color_status-warning-bg_11e91_666",
  "color_status-success": "_color_status-success_11e91_669",
  "color_status-success-bg": "_color_status-success-bg_11e91_672",
  "color_status-info": "_color_status-info_11e91_675",
  "color_status-info-bg": "_color_status-info-bg_11e91_678",
  "color_brand-green-new": "_color_brand-green-new_11e91_681",
  "color_brand-dark-new": "_color_brand-dark-new_11e91_684",
  "color_brand-white-new": "_color_brand-white-new_11e91_687",
  "color_brown-new": "_color_brown-new_11e91_690",
  "color_brown-hover-new": "_color_brown-hover-new_11e91_693",
  "color_stone-new": "_color_stone-new_11e91_696",
  "color_black-new": "_color_black-new_11e91_699",
  "color_red-1-new": "_color_red-1-new_11e91_702",
  "color_red-2-new": "_color_red-2-new_11e91_705",
  "color_red-stop-new": "_color_red-stop-new_11e91_708",
  "color_grey-1-new": "_color_grey-1-new_11e91_711",
  "color_grey-2-new": "_color_grey-2-new_11e91_714",
  "color_grey-3-new": "_color_grey-3-new_11e91_717",
  "color_grey-4-new": "_color_grey-4-new_11e91_720",
  "color_grey-5-new": "_color_grey-5-new_11e91_723",
  "color_grey-6-new": "_color_grey-6-new_11e91_726",
  "color_grey-7-new": "_color_grey-7-new_11e91_729",
  "color_off-white": "_color_off-white_11e91_732",
  "color_status-error-new": "_color_status-error-new_11e91_735",
  "color_status-error-bg-new": "_color_status-error-bg-new_11e91_738",
  "color_status-warning-new": "_color_status-warning-new_11e91_741",
  "color_status-warning-bg-new": "_color_status-warning-bg-new_11e91_744",
  "color_status-success-new": "_color_status-success-new_11e91_747",
  "color_status-success-bg-new": "_color_status-success-bg-new_11e91_750",
  "color_status-info-new": "_color_status-info-new_11e91_753",
  "color_status-info-bg-new": "_color_status-info-bg-new_11e91_756",
  "color_secondary-grey-2": "_color_secondary-grey-2_11e91_759",
  "color_color-success-filied-default": "_color_color-success-filied-default_11e91_762",
  noPadding: w_,
  noPadding_top: y_,
  noPadding_bottom: p_,
  btn: h_,
  disabled: S_,
  "slide-in-out": "_slide-in-out_11e91_1",
  "fade-in-out": "_fade-in-out_11e91_1"
}, M_ = (c) => {
  const {
    variant: e,
    size: s,
    weight: t = "",
    fontStyle: n = "",
    noPadding: o,
    color: r = "",
    children: a,
    className: i,
    component: l = "div",
    rootRef: d,
    dataTestId: b,
    ...u
  } = c, g = y(
    i,
    _[e],
    _[`${e}_${s}`],
    t && _[`weight_${t}`],
    n && _[`fontStyle_${n}`],
    r && _[`color_${r}`],
    o && (o === !0 ? _.noPadding : _[`noPadding_${o}`]),
    l === "button" && _.btn
  );
  return /* @__PURE__ */ w(l, { ref: d, className: g, ...u, "data-testid": b, children: a });
};
export {
  M_ as Typography
};
